module.exports = __webpack_public_path__ + "img/ball2_db.ed770e32.png";